const convertToUTC = (hours, minutes) => {
    const localTime = new Date();
    localTime.setHours(hours);
    localTime.setMinutes(minutes);
    return localTime.toISOString().substring(11, 16);
};

const convertUtcToLocal = hour => {
    const localTime = new Date(`01/01/2024 ${hour}:00:00 UTC`);
    return localTime.toString().substring(16, 21);
};

module.exports = {
    convertToUTC,
    convertUtcToLocal,
};
